import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";

export const OnBehalfOf = () => {
    const { preCertUserId, physicianId } = useParams<any>();
    var auth = React.useContext(AuthContext);

    auth.setOnBehalfOf(preCertUserId);
    var navigate = useNavigate();

    useEffect(() => {
        if (physicianId) {
            navigate(`/${physicianId}`, { replace: true });
        } else {
            navigate("/");
        }
    }, [])
    return <AbpnSpinner />;
}
